import { Component, OnInit } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { MatCard } from '@angular/material/card';
import { LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-maes-gwirio',
    templateUrl: './maes-gwirio.component.html',
    styleUrls: ['./maes-gwirio.component.scss'],
    imports: [MatCard, LayoutDirective, FaIconComponent, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, FormlyModule, UpperCasePipe, TranslatePipe]
})
export class MaesGwirioComponent extends FieldArrayType implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
